import type { FaireProductEntity } from "../../entity_types/product";

export const p_4dbpy35be8: FaireProductEntity = {
  token: "p_4dbpy35be8",
  type: "product",
  name: "Polka Dot WWJD Crewneck | Women's",
  brandToken: "b_p959n8n2zn",
  brandName: "Teigan & Co",
  imageUrl:
    "https://cdn.faire.com/fastly/967a7f178a72fec497b7fe72ce2265f7e6efda004be18f15cfd12735f9327455.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7b7fa6b7ae24fff9e34cf2662b3fc7e4acdd6eec5fb6cc9d4b04f210b3d8727.png",
  ],
  priceDollars: 28,
  description:
    "A timeless reminder with effortless style. This Women's Polka Dot WWJD Crewneck blends cozy comfort with a message that never goes out of style. Featuring bold WWJD lettering with playful polka dot detail, this sweatshirt is both meaningful and stylish for everyday wear.\n\nDesigned with a crisp white body and classic black ribbed collar, cuffs, and hem, this crewneck offers a clean contrast that pairs perfectly with denim, joggers, or leggings. The relaxed fit and soft feel make it an easy go-to for casual days, coffee runs, youth group nights, or simply staying cozy while keeping your faith front and center.\n\nBecause sometimes the best outfit is one that reminds us who we’re living for.\n\nFeatures\n\n• White crewneck sweatshirt with bold WWJD polka dot lettering\n• Classic black ribbed collar, cuffs, and bottom hem\n• Soft, comfortable fabric for everyday wear\n• Relaxed, easy-to-style fit\n• Faith-inspired design with a modern boutique feel\n\nStyling Tip\n\nPair with distressed denim and neutral sneakers for an easy everyday look, or layer it with a baseball cap and crossbody bag for a casual on-the-go outfit.\n\nSizes Available:\nSmall\nMedium\nLarge\nX-Large\n",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:08.944Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
